module.exports = __webpack_public_path__ + "static/explosiveWeapons-95e3288169af38f56390ead418b4f1e3.webp";